<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Tuinrenovatie</h1>

      <p>
        Is uw tuin verouderd? Of vindt u enkele delen in uw tuin gewoon niet
        meer mooi? Maar wilt u niet uw complete tuin veranderen? Dan is een
        tuinrenovatie wat voor u. Tijdens een tuinrenovatie worden enkele
        elementen of planten in tact gehouden en in de nieuwe tuin weer
        gebruikt. Op die manier bespaart u gemakkelijk in de kosten.
      </p>

      <h2>Geef uw tuin een nieuwe dimensie!</h2>
      <p>
        Met een kleine tuinrenovatie geeft u uw tuin al een hele andere look and
        feel. Met het gebruik van andere kleuren, andere accessoires, de aanleg
        van een nieuw terras of pad, het plaatsen van een vijver en het
        verplaatsen van enkele struiken en bomen oogt uw tuin als compleet
        nieuw! Het leuke van een tuinrenovatie is dat u zelf kunt bepalen welke
        onderdelen u in uw tuin wilt behouden.
      </p>

      <h2>Renovatievoorstel opstellen voor uw tuinrenovatie</h2>
      <p>
        Wanneer u uw tuin wilt renoveren komt de hovenier eerst uw tuin
        bekijken. Hier kunt u aangeven wat uw wensen zijn. U vertelt welke
        bomen, struiken of planten u mooi vindt en op welk plekje u in de tuin
        trots bent. Wilt u deze behouden en meenemen naar de nieuwe tuin? Dan
        kan dat! Aan de hand van uw wensen maakt de hovenier een
        renovatievoorstel. Dit voorstel kunt u samen met de hovenier nog eens
        bespreken. Hierna gaat de hovenier aan de slag en lijkt uw tuin, soms na
        wat kleine aanpassingen, als nieuw!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'HovenierVergelijker.nl | Bespaar op Tuinrenovatie',
      description:
        'Is uw tuin verouderd? Of vindt u enkele delen in uw tuin gewoon niet meer mooi? Bespaar op uw hovenierskosten.',
    }
  },
}
</script>
